<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >

            <rkm-row class="flex-nowrap">

                <rkm-col class="flex-grow-1">
                    <rkm-form-input
                        label="Descrição"
                        v-model="model.descricao"
                        :validations="validations.descricao"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Ordem"
                        v-model="model.ordem"
                        number
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        label="Situação"
                        text-field="descricao"
                        value-field="id"
                        v-model="model.situacaoId"
                        :options="data.form.composicaoSituacao"
                        :validations="validations.situacaoId"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="flex-grow-0">
                    <rkm-form-checkbox
                        v-model="model.padrao"
                        :label="false"
                    >
                        Padrão
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col class="flex-grow-0 text-nowrap">
                    <rkm-button
                        :label="false"
                        color="primary"
                        @click.stop="$refs.Form.validate(add)"
                    >
                    {{ hasIndex  ? 'Alterar' : 'Incluir' }}
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        color="secondary"
                        @click.stop="resetForm"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <List
            v-if="!hasIndex"
            ref="List"
            :data="data"
            :item="item"
            @handleAlter="handleAlter"
        />
    </div>
</template>

<script>

// Mixins.
import { repository, stringCase, object, error, } from '@/mixins'

// Components
import List from './List'

export default {
    components: {
        List,
    },
    computed: {
        maskValor(){

            var mascara = '##,##'

            if (this.data.model.laboratorio.valor && this.data.model.laboratorio.valor.length < 6){
                mascara = '##,##'
            }
            else if (this.data.model.laboratorio.valor && this.data.model.laboratorio.valor.length < 7){
                mascara = '###,##'
            }
            else if (this.data.model.laboratorio.valor && this.data.model.laboratorio.valor.length < 9){
                mascara = '#.###,##'
            }

            return mascara
        },
        validations() {
            return {
                valor: {max: 8},
                descricao: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                situacaoId: {
                    required: true,
                },
            }
        },
        hasIndex() {

            return this.index !== null
        },
    },
    data: () => ({
        model: {
            id: null,
            descricao: '',
            ordem: '',
            situacaoId: null,
            situacao: '',
            padrao: false,
        },
        index: null,
    }),
    mixins: [ repository, stringCase, object, error ],
    props: {
        data: { type: Object, required: true },
        item: { type: Object, required: true },
    },
    methods: {
       add() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    if (this.hasParametrizada()) {

                        this.showValidationNotification(
                            `Registro já parametrizado com a descrição <strong>${this.model.descricao}</strong>.`
                        )

                        return
                    }

                    if (this.model.padrao && this.hasPadraoParametrizado()) {

                        const confirm = async () => {

                            this.item.lista.forEach(lista => lista.padrao = false);

                            this.handleAdd()
                        }

                        const msg = `Já existe um registro padrão. Ao cadastrar um novo, o anterior deixará de ser padrão.
                            Deseja continuar?`

                        this.showConfirmation(msg, confirm)

                        return false
                    }

                    this.handleAdd()
            })
        },
        handleAdd() {

            const lista = this.clone(this.model)

            const situacao = this.data.form.composicaoSituacao.find(u => u.id === this.model.situacaoId)

            lista.situacao = situacao.descricao

            if (this.hasIndex) {

                const objId = this.item.lista.findIndex((obj => obj.id == this.model.id));

                this.$set(this.item.lista, objId, lista)
            } else {

                lista.id = this.uniqueId('lista' + new Date().getTime())

                this.item.lista.push(lista)
            }

            this.resetForm()
        },
        hasParametrizada() {

            return this.item.lista && this.item.lista.find((lista) => lista.id !== this.model.id
                && lista.descricao === this.model.descricao)
        },
        hasPadraoParametrizado() {

            return this.item.lista && this.item.lista.find((lista) => lista.id !== this.model.id
                && lista.padrao === true)
        },
        validate() {

            return this.$refs.Form.validate()
        },
        resetForm() {

            this.index = null

            this.model.id = null
            this.model.descricao = ''
            this.model.ordem = ''
            this.model.situacaoId = null
            this.model.padrao = false

            this.$nextTick(() => this.$refs.Form.resetValidator())
        },
        handleAlter(index, item) {

            this.index = index
            this.model.id = item.id
            this.model.descricao = item.descricao
            this.model.ordem = item.ordem
            this.model.situacaoId = item.situacaoId
            this.model.padrao = item.padrao
        }
    },
}
</script>